
<nb-card-body class="p-0" [nbSpinner]="isLoading">
  <div class="row px-4">
    <div class="col-12">
      <ejs-grid #grid [id]='gridName' [dataSource]="allFarms" [allowPaging]="true" [enableHover]="false"
        [allowSelection]="true" (toolbarClick)="this.toolbarClick($event)" [pageSettings]="this.pageSettings"
        [allowSorting]="true" [allowExcelExport]='true' [filterSettings]='this.filterSettings' [allowTextWrap]='true'
        [allowFiltering]="true"  [toolbar]="this.toolbarOptions" rowHeight="38"
        [enableStickyHeader]='true' height="600" [columns]="this.allColumns"
        (actionComplete)="onActionComplete($event)"
        (dataBound)="onGridDataBound()"
        (rowDataBound)="onRowDataBound($event)">
      </ejs-grid>
    </div>
  </div>
</nb-card-body>

<ng-template #farmNameTemplate let-data>
  <a href="javascript:void(0)" class="link" (click)="toLifecycle(data)">{{data.name}}</a>
</ng-template>

<ng-template #farmActionTemplate let-row>
  <ng-container *ngIf="!savingFarmIds.has(row.id); else farmSavingSpinner">
    <div class="d-flex ">
      <button class="btn btn-sm btn-active-primary btn-icon-hover me-1" (click)="addFarmClicked(true, row)">
        <fa-icon style="cursor: pointer;" [icon]="faPen"></fa-icon>
      </button>
      <button class="btn btn-sm btn-active-primary btn-icon-hover ms-1" (click)="confirmDelete(row.id)">
        <fa-icon style="cursor: pointer;" [icon]="faTrash"></fa-icon>
      </button>
    </div>
  </ng-container>
  <ng-template #farmSavingSpinner>
    <mat-spinner class="row-saving-spinner" [diameter]="20"></mat-spinner>
  </ng-template>
</ng-template>